<template>
    <div class="condition-line" style="padding: 0px; line-height: 0px">
        <div class="block">
            <el-select :size="size" v-model="checked.proviceID" @change="onProviceChanged" style="width: 150px">
                <el-option v-for="item in proviceList" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
            </el-select>
        </div>
        <div class="block" v-if="checked.proviceID">
            <el-select :size="size" v-model="checked.cityID" @change="onCityChanged" style="width: 150px">
                <el-option v-for="item in cityList" :key="item.DistrictID" :label="item.Name" :value="item.DistrictID"> </el-option>
            </el-select>
        </div>
        <div class="block" v-if="checked.cityID">
            <el-select :size="size" v-model="checked.areaID" @change="onAreaChanged" style="width: 150px">
                <el-option v-for="item in areaList" :key="item.DistrictID" :label="item.Name" :value="item.DistrictID"> </el-option>
            </el-select>
        </div>
    </div>
</template>
<script>
export default {
    name: "DistrictPicker",
    props: {
        size: {
            type: String,
            default: "small",
        },
        areaID: { type: String },
    },
    data() {
        return {
            proviceList: [],
            childrenList: [],
            cityList: [],
            areaList: [],
            checked: {
                proviceID: "",
                cityID: "",
                areaID: "",
            },
        };
    },
    created() {
        this.loadProvices();
    },
    methods: {
        loadProvices() {
            this.$ajax.post("/Metadata/GetProviceList", {}).then((res) => {
                this.proviceList = res.Data;
                if (this.areaID && this.areaID.length == 6) {
                    this.bindCheckedArea(this.areaID);
                }
            });
        },
        bindCheckedArea(areaID) {
            let provice = areaID.substr(0, 2) + "0000";
            var arrPro = this.proviceList.filter((r) => r.Value == provice);
            if (arrPro.length > 0) {
                this.checked.proviceID = arrPro[0].Value;
                this.getCityDatas().then((res) => {
                    this.childrenList = res.Data;
                    this.cityList = this.getCitys(this.checked.proviceID);
                    let arrAreas = this.childrenList.filter((r) => r.DistrictID == areaID);
                    if (arrAreas.length > 0) {
                        this.checked.areaID = arrAreas[0].DistrictID;
                        this.checked.cityID = arrAreas[0].CityCode;
                        this.areaList = this.getAreas(this.checked.cityID);
                    }
                });
            }
        },
        onProviceChanged() {
            this.cityList = [];
            this.areaList = [];
            this.checked.cityID = "";
            this.checked.areaID = "";
            if (!this.checked.proviceID) {
                return;
            }
            this.getCityDatas().then((res) => {
                this.childrenList = res.Data;
                this.cityList = this.getCitys(this.checked.proviceID);
            });
            this.$emit("change", this.checked);
        },
        getCityDatas() {
            return this.$ajax.post("/Metadata/GetProviceCityAndAreas?id=" + this.checked.proviceID, {});
        },
        onCityChanged() {
            this.areaList = [];
            this.checked.areaID = "";
            if (!this.checked.cityID) {
                return;
            }
            this.areaList = this.getAreas(this.checked.cityID);
            this.$emit("change", this.checked);
        },
        onAreaChanged() {
            this.$emit("change", this.checked);
        },
        getCheckeds() {
            return this.checked;
        },
        getCitys(code) {
            if (code) {
                return this.childrenList.filter((r) => r.ProvinceCode == code && r.DistrictID.substr(4, 2) == "00");
            } else {
                return [];
            }
        },
        getAreas(code) {
            if (code) {
                return this.childrenList.filter((r) => r.CityCode == code);
            } else {
                return [];
            }
        },
    },
    watch: {
        areaID: function (newVal) {
            if (newVal) {
                this.bindCheckedArea(newVal);
            } else {
                this.checked = {
                    proviceID: "",
                    cityID: "",
                    areaID: "",
                };
            }
        },
    },
};
</script>
<style scoped>
.ly-search-param {
    margin-bottom: 5px;
}
</style>
